import type { SkillDef } from "@/mocks/pipeline";

// toPalette converts an API skill into a palette SkillDef, copying discipline
// from the server when present.
export function toPalette(s: { id: string; name: string; category: string; description: string; discipline?: string }, fallbackDesc = ''): SkillDef {
  return {
    id: s.id,
    name: s.name,
    category: s.category || 'Other',
    icon: 'ri-magic-line',
    description: s.description || fallbackDesc,
    body: '',
    version: '',
    latency: '',
    inputs: [],
    outputs: [],
    discipline: s.discipline && s.discipline.trim() !== '' ? s.discipline : 'Uncategorized',
  };
}
